<template>
  <div class="article-subscribe">
    <div class="article-subscribe-desc">
      讓 MUZIK 繼續為您提供古典樂新知現在就成為訂閱會員
    </div>
    <router-link :to="{ name: 'membership'}" tag="button" class="article-subscribe-button">
      訂閱方案
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ArticleSubscribeBlock'
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.article-subscribe {
  width: 100%;
  height: 415px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.article-subscribe-desc {
  max-width: 405px;
  min-height: 70px;
  font-family: NotoSerifCJKtc;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #525252;
  margin-bottom: 24px;
}

.article-subscribe-button {
  color: #ffffff;
  font-family: "Noto Sans TC", sans-serif;
  font-size: 16px;
  font-weight: bold;
  width: 280px;
  height: 47px;
  border-radius: 8px;
  background-color: $theme-yellow;
}

@media only screen and (max-width: 767.98px) {
  .article-subscribe {
    height: 269px;
  }

  .article-subscribe-desc {
    max-width: 270px;
    min-height: 46px;
    font-size: 16px;
    margin-bottom: 35px;
  }
}
</style>
